// Psychologist/PsychologistAboutTabs.tsx
import React, {useState} from 'react';
import {IPsychologist} from "../../Types/psychology/psychologist";
import TabButton from "Core/components/elements/Tabs/TabButton";
import {useTheme} from 'Theme/ThemeContext';
import PsychologistFeedbacks from "../ConsultationFeedback/PsychologistFeedbacks";
import {FC, FR} from "WideLayout/Layouts";

interface PsychologistAboutTabsProps {
    psychologist: IPsychologist;
}

const MAX_LENGTH = 300;

const PsychologistAboutTabs: React.FC<PsychologistAboutTabsProps> = ({psychologist}) => {
    const {plt} = useTheme();
    const [activeTab, setActiveTab] = useState<'description' | 'education' | 'experience' | 'feedbacks'>('description');
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [isEducationExpanded, setIsEducationExpanded] = useState(false);
    const [isExperienceExpanded, setIsExperienceExpanded] = useState(false);

    const toggleDescription = () => {
        setIsDescriptionExpanded((prev) => !prev);
    };
    const toggleExperience = () => {
        setIsExperienceExpanded((prev) => !prev);
    };

    const toggleEducation = () => {
        setIsEducationExpanded((prev) => !prev);
    };

    const renderContent = (content: string | null, isExpanded: boolean, toggleExpand: () => void) => {
        if (!content) return <p>Информация отсутствует.</p>;
        if (content.length <= MAX_LENGTH) return <p style={{whiteSpace: 'pre-wrap'}}>{content}</p>;
        const displayedText = isExpanded ? content : `${content.substring(0, MAX_LENGTH)}...`;
        return (
            <div>
                <span style={{whiteSpace: 'pre-wrap'}}>{displayedText}</span>
                <button
                    onClick={toggleExpand}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: plt.colors.secondary.main,
                        cursor: 'pointer',
                        paddingLeft: '5px',
                        textDecoration: 'underline',
                        fontSize: '1em', // Подстройка размера шрифта под текст
                        lineHeight: '1.5', // Совместимая высота строки
                        verticalAlign: 'middle', // Выравнивание по центру
                    }}
                >
                    {isExpanded ? 'Скрыть' : 'Читать далее...'}
                </button>
            </div>
        );
    };

    return (
        <FC>
            <FR wrap gap={1} mb={1}>
                <TabButton
                    active={activeTab === 'description'}
                    onClick={() => setActiveTab('description')}
                    textSx={{padding: '.2rem 1rem'}}>
                    Описание
                </TabButton>
                <TabButton
                    active={activeTab === 'education'}
                    onClick={() => setActiveTab('education')}
                    textSx={{padding: '.2rem 1rem'}}>
                    Образование
                </TabButton>
                <TabButton
                    active={activeTab === 'experience'}
                    onClick={() => setActiveTab('experience')}
                    textSx={{padding: '.2rem 1rem'}}>
                    Опыт
                </TabButton>
                <TabButton
                    active={activeTab === 'feedbacks'}
                    onClick={() => setActiveTab('feedbacks')}
                    textSx={{padding: '.2rem 1rem'}}>
                    Отзывы
                </TabButton>
            </FR>
            <FC>
                {activeTab === 'description'
                    ? renderContent(psychologist.about_me, isDescriptionExpanded, toggleDescription)
                    : activeTab === 'education'
                        ? renderContent(psychologist.education, isEducationExpanded, toggleEducation)
                        : activeTab === 'experience'
                            ? renderContent(psychologist.experience_text, isExperienceExpanded, toggleExperience)
                            : <PsychologistFeedbacks psychologistUserId={psychologist.user.id}/>}
            </FC>
        </FC>
    );
};

export default PsychologistAboutTabs;
